import { render, staticRenderFns } from "./MaterialSelector.vue?vue&type=template&id=324c4a52&"
import script from "./MaterialSelector.vue?vue&type=script&lang=ts&"
export * from "./MaterialSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports